export enum DrillScoring {
  RepsOnly = 'REPS_ONLY',
  TimePerRep = 'TIME_PER_REP',
  HitFactor = 'HIT_FACTOR'
}
